export const getEndpoints = (params = {}) => {
  const {
    vendorId = '',
    assignmentDetailId = '',
    lotNumber = '',
    truckId = '',
    tripId = '',
    messageId = '',
    country = '',
    vendorPersonnelId = '',
    catSubhaulerId = '',
  } = params
  return {
    // View Api
    lotsView: '/services/ycsdispatchuk/transporter/assignments',
    tripsView: '/services/ycsdispatchuk/transporter/trips',
    driversView: '/services/ycsdispatchuk/transporter/drivers',
    workRequestsView: '/services/ycsdispatchuk/transporter/work_requests',

    // Login Api
    login: '/services/ycsdispatchuk/transporter/login',
    userDetails: '/services/ycsdispatchuk/transporter/current_user',
    externalUserSettings: '/services/ycstsmus/personnel/external_user_settings',
    sendOTP: '/services/ycstsmus/personnel/external_user/otp',
    verifyOTP: '/services/ycstsmus/personnel/external_user/otp/validate',
    changePassword: '/services/ycsdispatchuk/transporter/password',
    refreshToken: '/services/ycsdispatchuk/transporter/client/token',
    personnels: `/services/transportersetup-ws/v1/vendors/${vendorId}/personnel`,

    // Reference Data
    referenceData: '/services/ycstsmus/tsm/reference_data?data_type=all',

    //Quick Counts
    quickCounts: '/services/ycsdispatchuk/transporter/quick_counts',
    issueQuickCounts: '/services/ycsdispatchuk/transporter/issues_quick_counts',

    //Work Requests
    createRequest: '/services/ycsdispatchuk/transporter/work_requests',
    deleteRequest: '/services/ycsdispatchuk/transporter/work_requests',

    //View Lot
    getLotInfo: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}`,
    getNotes: `/services/notes-ws/lots/${lotNumber}/notes`,
    getCharges: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/charges`,

    //Trips
    overrideDeclineTrip: `/services/ycsdispatchuk/transporter/trips/${tripId}/override_rejection`,
    reclaimTrip: '/services/ycsdispatchuk/transporter/trips/reclaim',
    transitionTrip: '/services/ycsdispatchuk/transporter/trips/transition',
    cancelDeclineTrip: `/services/ycsdispatchuk/transporter/trips/${tripId}/override_rejection`,
    declineReason: `/services/ycsdispatchuk/transporter/decline_reasons`,
    updateTransitions: `/services/ycsdispatchuk/transporter/trips/transition`,

    //Lots
    available_issues: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/available_issues`,
    submitIssue: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/issues`,
    distributeTrip: `/services/ycsdispatchuk/transporter/vendors/${vendorId}/groups`,
    submitDistributeTripAssignments:
      '/services/ycsdispatchuk/transporter/assignments/distribute',
    submitDistributeTrips:
      '/services/ycsdispatchuk/transporter/trips/distribute',
    getIssueDetail: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/issues`,
    resolveIssue: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/issues/resolve`,
    escalate: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/issues/escalate`,
    markAsRead: `/services/ycsdispatchuk/transporter/assignments/${assignmentDetailId}/issues/${messageId}/read`,
    sendEmail: `/services/ycsdispatchuk/transporter/feedback`,
    workingDays: '/services/ycsdispatchuk/dispatch/two_working_days',

    //Drivers
    addPersonnel: `/services/ycsdispatchuk/transporter/vendors/${vendorId}/personnel`,
    updatePersonnel: `/services/ycsdispatchuk/transporter/vendors/${vendorId}/personnel/${vendorPersonnelId}`,
    subhauler: `/services/ycstsmus/subhauler_deployment/subhauler/${vendorId}`,
    subhaulers: `/services/ycstsmus/subhauler_deployment/subhaulers/${catSubhaulerId}`,
    catList: '/services/ycstsmus/subhauler_deployment/cat_list',
    manageDriver: `/services/ycstsmus/subhauler_deployment/subhaulers/${catSubhaulerId}/manage_drivers`,
    association: `/services/ycstsmus/subhauler_deployment/subhaulers/${catSubhaulerId}/drivers/association`,

    //capacities
    capacities: `/services/ycsdispatchuk/transporter/vendor/${vendorId}/capacities`,
    yards: `/services/transportersetup-ws/v1/vendors/${vendorId}/yards`,
  }
}
